var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.cssClass},[_vm._m(0),_c('div',{staticClass:"c-loading-chara__content"},[(_vm.$slots.title)?_c('p',{staticClass:"c-loading-chara__title"},[_vm._t("title")],2):_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-loading-chara__image"},[_c('img',{attrs:{"src":require("@/assets/img/img-chara-normal.svg"),"alt":""}})])
}]

export { render, staticRenderFns }